import { Search, ChevronUp, ChevronDown } from "lucide-react";

const ListView = ({
  families,
  searchQuery,
  onSearchChange,
  onEdit,
  onAdd,
  sortColumn,
  sortDirection,
  onSort,
  onToggleSelect,
  onToggleSelectAll,
  allSelected,
  anySelected,
  onDeleteItems,
}) => {
  const getColorStyle = (familyCode, familyName) => {
    if (familyCode === "#" || familyName.toLowerCase() === "clear") {
      return "color-families__color-preview--transparent";
    }
    if (familyCode === "*" || familyName.toLowerCase() === "multicolor") {
      return "color-families__color-preview--multicolor";
    }
    return "";
  };

  const getColorBackground = (familyCode, familyName) => {
    if (familyCode === "#" || familyName.toLowerCase() === "clear") {
      return {};
    }
    if (familyCode === "*" || familyName.toLowerCase() === "multicolor") {
      return {};
    }
    const hexCode = familyCode.startsWith("#") ? familyCode : `#${familyCode}`;
    return { backgroundColor: hexCode };
  };

  const SortIcon = ({ column }) => {
    if (sortColumn !== column) {
      return (
        <ChevronUp
          className="color-families__sort-icon"
          style={{ opacity: 0.3 }}
        />
      );
    }
    return sortDirection === "asc" ? (
      <ChevronUp className="color-families__sort-icon" />
    ) : (
      <ChevronDown className="color-families__sort-icon" />
    );
  };

  return (
    <>
      <div className="color-families__controls">
        <div className="color-families__search-wrapper">
          <Search className="color-families__search-icon" size={18} />
          <input
            type="text"
            className="color-families__search"
            placeholder=" Search color families"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        {allSelected || anySelected ? (
          <div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
            <button
              className="color-families__delete-btn"
              onClick={onDeleteItems}
            >
              {`Delete ${allSelected ? "all items" : "seleted items"}`}
            </button>
          </div>
        ) : (
          <div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
            <button className="color-families__edit-btn" onClick={onEdit}>
              Edit families
            </button>
            <button className="color-families__add-btn" onClick={onAdd}>
              +
            </button>
          </div>
        )}
      </div>

      <div className="color-families__table-wrapper">
        <table className="color-families__table">
          <thead>
            <tr>
              <th>
                <span
                  className="color-families__sort-header"
                  onClick={() => onSort("familyName")}
                >
                  Family name
                  <SortIcon column="familyName" />
                </span>
              </th>
              <th>Family code & Pattern</th>
              <th>Colors in Family</th>
              <th>
                <div className="color-families__select-all">
                  Select all
                  <input
                    type="checkbox"
                    className="color-families__checkbox"
                    checked={allSelected}
                    onChange={onToggleSelectAll}
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {families.map((family) => (
              <tr key={family.id}>
                <td>
                  <strong>{family.familyName}</strong>
                </td>
                <td>
                  {family.url ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div
                        className="color-families__list-photo-inline"
                        style={{
                          marginLeft: "0px",
                          width: "36px",
                          height: "36px",
                          borderRadius: "3px",
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        <img
                          src={family.url}
                          alt="Pattern"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <span style={{ fontSize: '12px', color: '#64748b' }}>Image</span>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div
                        className={`color-families__color-preview ${getColorStyle(
                          family.familyCode,
                          family.familyName
                        )}`}
                        style={getColorBackground(
                          family.familyCode,
                          family.familyName
                        )}
                      />
                      <span>{family.familyCode}</span>
                    </div>
                  )}
                </td>
                <td>{family.colorsIncluded}</td>
                <td>
                  {!["#", "*"].includes(family.familyCode) && (
                    <input
                      type="checkbox"
                      className="color-families__checkbox"
                      checked={family.selected || false}
                      onChange={() => onToggleSelect(family.id)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListView;
